























































/* General */
import Vue from 'vue'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from 'vue-content-placeholders'
import {
  IBreadcrumbDataFromListing,
  INavMenuItem,
} from '@/types/data-objects/global'

/* Mixins */

/* Components */

/* Helpers */
import ItemFilterAssistant from '@/helpers/item-filter-assistant'
import TextAssistant from '@/helpers/text-assistant'
import BreadcrumbAssistant from '@/helpers/breadcrumb-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default Vue.extend({
  name: 'BreadcrumbForListing',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },

  props: {
    isCustomFilterSubmitting: {
      type: Boolean,
      default: false,
    },
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    selectedEntityId: {
      type: Number,
      default: null,
    },
    isKanban: {
      type: Boolean,
      default: false,
    },
    totalItemCount: {
      type: Number,
      default: null,
    },
    defaultFilters: {
      type: Array as () => INavMenuItem[],
      required: true,
    },
    customFilters: {
      type: Array as () => INavMenuItem[],
      required: true,
    },
    currentFilter: {
      type: Object as () => INavMenuItem,
      required: true,
    },
  },

  data() {
    return {
      EEntities,
      ItemFilterAssistant,
      userWantsToChangeName: false,
      newName: '',
    }
  },
  computed: {
    isAllConversations(): boolean {
      return (
        this.entityType === EEntities.MAILBOXES &&
        this.selectedEntityId === null
      )
    },
    isAllTasks(): boolean {
      return (
        this.entityType === EEntities.PROJECTS && this.selectedEntityId === null
      )
    },
    newNameIsEmpty(): boolean {
      return this.newName.trim() === ''
    },
    showNameForm(): boolean {
      return this.userWantsToChangeName && this.renameable
    },
    renameable(): boolean {
      return this.isUnnamedFilter || this.isCustomFilter
    },
    isCustomFilter(): boolean {
      return ItemFilterAssistant.isCustomIdentifier(this.currentFilter.value)
    },
    iconName(): string {
      if (this.isAllConversations) {
        return TextAssistant.itemSingularName(EEntities.MAILBOXES).toLowerCase()
      }
      if (this.isAllTasks) {
        return TextAssistant.itemSingularName(EEntities.PROJECTS).toLowerCase()
      }
      return TextAssistant.entitySingularName(this.entityType).toLowerCase()
    },
    arrowClasses(): string {
      if (this.$screen.isDesktop(this.$mq)) {
        return 'ddi ddi-caret-right'
      }
      return 'hidden'
    },
    isUnnamedFilter(): boolean {
      return (
        this.currentFilter.value ===
        ItemFilterAssistant.getUnnamedFilterIdentifier()
      )
    },
  },

  watch: {
    /* These are the only two things that would change after the initial
       load of the project/mailbox home, so watch them to keep the cached
       filter state synced after the component load. */
    /* This is loaded async, so refresh breadcrumb data cache as needed */
    totalItemCount() {
      this.cacheBreadcrumbDataFromListing()
    },
    currentFilter() {
      this.cacheBreadcrumbDataFromListing()
    },
    showNameForm: {
      handler(show) {
        if (show) {
          if (this.isCustomFilter) {
            this.newName = this.currentFilter.label
          } else if (this.isUnnamedFilter) {
            this.newName = ''
          }
          this.$nextTick(() => {
            // @ts-ignore
            this.$refs.inputRef.focus()
          })
        } else {
          this.userWantsToChangeName = false
        }
      },
    },
    isCustomFilterSubmitting: {
      handler(val) {
        if (!val) {
          // If a submit has finished, "close" the name form
          this.userWantsToChangeName = false
        }
      },
    },
  },

  created() {
    this.cacheBreadcrumbDataFromListing()
  },

  methods: {
    cacheBreadcrumbDataFromListing() {
      const data = {
        title: this.title,
        iconName: this.iconName,
        entityType: this.entityType,
        selectedEntityID: this.selectedEntityId,
        totalItemCount: this.totalItemCount,
        defaultFilters: this.defaultFilters,
        customFilters: this.customFilters,
        currentFilter: this.currentFilter,
      } as IBreadcrumbDataFromListing

      BreadcrumbAssistant.cacheBreadcrumbDataFromListing(this.$store, data)
    },
    upsertFilter() {
      if (this.isUnnamedFilter) {
        this.$emit('save-new-filter', this.newName)
      } else if (this.isCustomFilter) {
        this.$emit('update-custom-filter-name', this.newName)
      }
    },
  },
})
